import BotoesSalvarExcluir from '@/shared/components/forms/BotoesSalvarExcluir';
import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import ModalHistorico from '@/modules/system/historico/ModalHistorico';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { DataAmigavel } from '@/shared/utils/datas';
import { EditadoPorRodape } from '@/shared/components/EditadoPorRodape';
import { EnumerateDefensores } from '@/modules/people/defensor.service';
import { GetDiretoria, SetDiretoria, DeleteDiretoria, GetDiretoriaLotacoes, SetDiretoriaLotacao, DeleteDiretoriaLotacao, GetDefensoriasPorDiretoria, SetDefensoriaDiretoria } from '@/modules/structure/diretoria/diretoria.service';
import { GetDefensorias } from '@/modules/structure/defensoria/defensoria.service';
import { diretoriaFormSchema, diretoriaLotacaoFormSchema } from '@/modules/structure/diretoria/diretoria.schema';
import { FieldError, formControlClass, formSelectClass } from '@/shared/components/forms/FormFieldFeedback';
import { zodResolver } from '@hookform/resolvers/zod';
import { useNavigate, useParams } from 'react-router-dom';
import { Modal, Button, Form, Col, Row } from 'react-bootstrap';
import { ReadDiretoriaDto, ReadDiretoriaLotacaoDto, CreateDiretoriaLotacaoDto, ReadDefensoriaDto } from '@/api.types';
import { SubmitHandler, useForm, type Resolver } from 'react-hook-form';
import { Tabelas } from '@/shared/constants/tables';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';

interface IOpcao { value: number; label: string; }
type DiretoriaLotacaoFormDto = CreateDiretoriaLotacaoDto & { diretor?: boolean };

function ordenarDefensoriasPorComarcaENome(a: ReadDefensoriaDto, b: ReadDefensoriaDto) {
  const comarcaA = a.comarca?.nome ?? '';
  const comarcaB = b.comarca?.nome ?? '';
  const cmpComarca = comarcaA.localeCompare(comarcaB, 'pt-BR');
  if (cmpComarca !== 0) return cmpComarca;
  return (a.nome ?? '').localeCompare(b.nome ?? '', 'pt-BR');
}

export default function DiretoriaEditPage() {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm<ReadDiretoriaDto>({
    resolver: zodResolver(diretoriaFormSchema) as unknown as Resolver<ReadDiretoriaDto>,
    mode: 'onTouched',
  });
  const { setActions } = useBreadcrumbActions();
  const navigate = useNavigate();
  const params = useParams();

  const [modaExcluirShow, setModalExcluirShow] = useState(false);
  const [modalHistorico, setModalHistorico] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalLotacaoShow, setModalLotacaoShow] = useState(false);
  const [lotacaoIndex, setLotacaoIndex] = useState(-1);
  const [lotacoes, setLotacoes] = useState<ReadDiretoriaLotacaoDto[]>([]);
  const [defensores, setDefensores] = useState<IOpcao[]>([]);
  const [lotacaoParaExcluir, setLotacaoParaExcluir] = useState<number | null>(null);
  const [defensorias, setDefensorias] = useState<ReadDefensoriaDto[]>([]);
  const [modalDefensoriaShow, setModalDefensoriaShow] = useState(false);
  const [defensoriaSelecionadaId, setDefensoriaSelecionadaId] = useState('');
  const [defensoriasDisponiveis, setDefensoriasDisponiveis] = useState<IOpcao[]>([]);
  const [defensoriaParaDesassociar, setDefensoriaParaDesassociar] = useState<number | null>(null);

  const id = params.id ? Number(params.id) : 0;
  const btnSalvar = id > 0 ? 'Salvar' : 'Cadastrar';

  const onInvalid = () => {
    toast.error('Corrija os campos destacados antes de salvar.');
  };

  const onInvalidLotacao = () => {
    toast.error('Corrija os campos destacados antes de salvar.');
  };

  const [loaded, setLoaded] = useState<boolean>(false);

  const {
    register: registerLotacao,
    handleSubmit: handleSubmitLotacao,
    reset: resetLotacao,
    formState: { errors: errorsLotacao },
  } = useForm<DiretoriaLotacaoFormDto>({
    resolver: zodResolver(diretoriaLotacaoFormSchema) as unknown as Resolver<DiretoriaLotacaoFormDto>,
    mode: 'onTouched',
  });

  useEffect(() => {
    setActions({
      secondary: { label: 'Novo', href: Links.Diretoria_Criar, onClick: () => { } },
      history: { label: 'Histórico', onClick: () => setModalHistorico(true) },
    });
    return () => setActions({});
  }, [setActions]);

  async function buscar() {
    if (id > 0) {
      await GetDiretoria(id)
        .then((result) => {
          reset(result);
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });

      await GetDiretoriaLotacoes(id)
        .then((result) => {
          setLotacoes(result);
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });

      await GetDefensoriasPorDiretoria(id)
        .then((result) => {
          setDefensorias([...result].sort(ordenarDefensoriasPorComarcaENome));
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });
    }
  }

  useEffect(() => {
    Promise.all([
      EnumerateDefensores(0, 1000, false, true, 'nome', true, '', '').then((result) => {
        setDefensores(
          result.objects.map((item) => {
            return { value: item.id, label: item.pessoa!.nome };
          }),
        );
      }),
      buscar(),
    ])
      .then(() => setLoaded(true))
      .catch((res) => {
        toast.error((res as string) + '');
      });
  }, []);

  const onSubmit: SubmitHandler<ReadDiretoriaDto> = (data) => {
    setIsLoading(true);
    const dados: ReadDiretoriaDto = {
      id: id,
      nome: data.nome,
    } as ReadDiretoriaDto;

    SetDiretoria(dados)
      .then((res) => {
        toast.success(res + '');
        navigate(`${Links.Diretoria_Index}`);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      })
      .finally(() => setIsLoading(false));
  };

  const handleExcluirDiretoria = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setModalExcluirShow(false);
    DeleteDiretoria(id)
      .then((res) => {
        toast.success(res + '');
        navigate(`${Links.Diretoria_Index}`);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  };

  const onSubmitLotacao: SubmitHandler<DiretoriaLotacaoFormDto> = (data) => {
    if (!id || id <= 0) {
      toast.warning('Salve a diretoria antes de adicionar lotações.');
      return;
    }

    const lotacaoData: CreateDiretoriaLotacaoDto = {
      id: lotacaoIndex >= 0 && lotacoes[lotacaoIndex]?.id ? lotacoes[lotacaoIndex].id : undefined,
      diretoria: { id: id },
      defensor: { id: Number(data.defensor.id) },
      inicio: data.inicio,
      fim: data.fim || undefined,
      diretor: Boolean(data.diretor),
    };

    SetDiretoriaLotacao(lotacaoData)
      .then((res) => {
        toast.success(res + '');
        setModalLotacaoShow(false);
        resetLotacao();
        setLotacaoIndex(-1);
        buscar();
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  };

  const handleEditarLotacao = (index: number) => {
    const lotacao = lotacoes[index];
    setLotacaoIndex(index);
    resetLotacao({
      defensor: { id: lotacao.defensor.id },
      inicio: lotacao.inicio ? new Date(lotacao.inicio).toISOString().split('T')[0] : '',
      fim: lotacao.fim ? new Date(lotacao.fim).toISOString().split('T')[0] : '',
      diretor: Boolean((lotacao as ReadDiretoriaLotacaoDto & { diretor?: boolean }).diretor),
    });
    setModalLotacaoShow(true);
  };

  const handleExcluirLotacao = () => {
    if (lotacaoParaExcluir !== null) {
      DeleteDiretoriaLotacao(lotacaoParaExcluir)
        .then((res) => {
          toast.success(res + '');
          setLotacaoParaExcluir(null);
          buscar();
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });
    }
  };

  const abrirModalAdicionarLotacao = () => {
    setLotacaoIndex(-1);
    resetLotacao();
    setModalLotacaoShow(true);
  };

  const abrirModalAssociarDefensoria = async () => {
    try {
      const result = await GetDefensorias(0, 9000);
      const idsVinculadas = new Set(defensorias.map((d) => d.id));
      setDefensoriasDisponiveis(
        result.objects
          .filter((item) => !idsVinculadas.has(item.id))
          .sort(ordenarDefensoriasPorComarcaENome)
          .map((item) => ({
            value: item.id!,
            label: `${item.comarca?.nome ?? 'Sem comarca'} - ${item.nome ?? ''}`,
          })),
      );
      setDefensoriaSelecionadaId('');
      setModalDefensoriaShow(true);
    } catch (res) {
      toast.error((res as string) + '');
    }
  };

  const handleAssociarDefensoria = async () => {
    if (!defensoriaSelecionadaId) {
      toast.warning('Selecione uma defensoria.');
      return;
    }

    try {
      const msg = await SetDefensoriaDiretoria(Number(defensoriaSelecionadaId), id);
      toast.success(msg + '');
      setModalDefensoriaShow(false);
      await buscar();
    } catch (res) {
      toast.error((res as string) + '');
    }
  };

  const handleDesassociarDefensoria = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (defensoriaParaDesassociar === null) return;

    SetDefensoriaDiretoria(defensoriaParaDesassociar, null)
      .then((msg) => {
        toast.success(msg + '');
        setDefensoriaParaDesassociar(null);
        setModalExcluirShow(false);
        buscar();
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  };

  if (!loaded) return <Loading />;

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3>Diretoria</h3>
        </div>
      </div>
      <hr className="pb-4" />

      <form
        onSubmit={(event) => {
          void handleSubmit(onSubmit, onInvalid)(event);
        }}
      >
        <div className="row">
          <div className="mb-3 col-md-12">
            <label htmlFor="nome" className="form-label">
              Nome da Diretoria: <span className="text-danger">*</span>
            </label>
            <input
              title="nome"
              type="text"
              className={formControlClass(!!errors.nome)}
              {...register('nome')}
            />
            <FieldError message={errors.nome?.message} />
          </div>
        </div>

        {id > 0 && (
          <Row className="mb-3">
            <Col md={7}>
              <div className="card h-100">
                <div className="card-header d-flex justify-content-between align-items-center py-2">
                  <h5 className="mb-0">Defensorias ({defensorias.length})</h5>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => void abrirModalAssociarDefensoria()}
                    title="Associar defensoria a esta diretoria"
                  >
                    Associar Defensoria
                  </button>
                </div>
                <div className="card-body">
                  <table className="table table-sm table-bordered table-hover table-striped mb-0">
                    <thead>
                      <tr>
                        <th className="text-start">Comarca</th>
                        <th className="text-start">Nome</th>
                        <th className="text-center">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {defensorias.map((defensoria) => (
                        <tr key={defensoria.id}>
                          <td className="text-start">{defensoria.comarca?.nome ?? '-'}</td>
                          <td className="text-start">{defensoria.nome}</td>
                          <td className="text-center">
                            <button
                              type="button"
                              className="btn btn-link p-0"
                              title="Remover associação com esta diretoria"
                              onClick={() => {
                                setDefensoriaParaDesassociar(defensoria.id!);
                                setLotacaoParaExcluir(null);
                                setModalExcluirShow(true);
                              }}
                            >
                              <FaTrash size={18} color="#dc3545" />
                            </button>
                          </td>
                        </tr>
                      ))}
                      {defensorias.length === 0 && (
                        <tr>
                          <td colSpan={3} className="text-center">
                            Nenhuma defensoria associada.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>

            <Col md={5}>
              <div className="card h-100">
                <div className="card-header d-flex justify-content-between align-items-center py-2">
                  <h5 className="mb-0">Lotações</h5>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={abrirModalAdicionarLotacao}
                    title="Adicionar nova lotação"
                  >
                    Adicionar Lotação
                  </button>
                </div>
                <div className="card-body">
                  <table className="table table-sm table-bordered table-hover table-striped text-center mb-0">
                    <thead>
                      <tr>
                        <th>Defensor</th>
                        <th>Início</th>
                        <th>Fim</th>
                        <th>Diretor</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lotacoes.map((lotacao, index) => (
                        <tr key={lotacao.id}>
                          <td>{lotacao.defensor.pessoa?.nome}</td>
                          <td>{DataAmigavel(lotacao.inicio)}</td>
                          <td>{lotacao.fim ? DataAmigavel(lotacao.fim) : '-'}</td>
                          <td>{(lotacao as ReadDiretoriaLotacaoDto & { diretor?: boolean }).diretor ? 'Sim' : ''}</td>
                          <td>
                            <div className="d-flex justify-content-center gap-1">
                              <button
                                type="button"
                                className="btn btn-link p-0"
                                title="Editar lotação"
                                onClick={() => handleEditarLotacao(index)}
                              >
                                <FaEdit size={18} color="#212529" />
                              </button>
                              <button
                                type="button"
                                className="btn btn-link p-0"
                                title="Remover lotação"
                                onClick={() => {
                                  setLotacaoParaExcluir(lotacao.id);
                                  setDefensoriaParaDesassociar(null);
                                  setModalExcluirShow(true);
                                }}
                              >
                                <FaTrash size={18} color="#dc3545" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                      {lotacoes.length === 0 && (
                        <tr>
                          <td colSpan={5} className="text-center">
                            Nenhuma lotação cadastrada.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {id > 0 && (
          <EditadoPorRodape dados={{ editadoPor: watch('editadoPor'), editadoEm: watch('editadoEm') }} />
        )}

        <div>
          <BotoesSalvarExcluir
            isLoading={isLoading}
            texto={btnSalvar}
            textoLoading={btnSalvar === 'Cadastrar' ? ' Cadastrando...' : ' Salvando...'}
            id={id}
            onExcluirClick={() => setModalExcluirShow(true)}
          />
        </div>

      </form>

      <ModalHistorico
        show={modalHistorico}
        handleHide={() => setModalHistorico(false)}
        tabela={Tabelas.diretoria}
        idRegistro={id}
      />

      <ModalExcluir
        show={modaExcluirShow}
        handleExcluir={
          defensoriaParaDesassociar !== null
            ? handleDesassociarDefensoria
            : lotacaoParaExcluir !== null
              ? handleExcluirLotacao
              : handleExcluirDiretoria
        }
        handleHide={() => {
          setModalExcluirShow(false);
          setLotacaoParaExcluir(null);
          setDefensoriaParaDesassociar(null);
        }}
        mensagemPersonalizada={
          defensoriaParaDesassociar !== null
            ? 'Tem certeza que deseja remover a associação desta defensoria com a diretoria?'
            : undefined
        }
      />

      <Modal show={modalLotacaoShow} onHide={() => setModalLotacaoShow(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {lotacaoIndex >= 0 ? 'Editar ' : 'Adicionar '} Lotação
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={(event) => {
              void handleSubmitLotacao(onSubmitLotacao, onInvalidLotacao)(event);
            }}
          >
            <Row className="mb-3">
              <Form.Group as={Col} md="12" className="mb-3">
                <label htmlFor="defensor" className="form-label">
                  Defensor: <span className="text-danger">*</span>
                </label>
                <select
                  id="defensor"
                  className={formSelectClass(!!errorsLotacao.defensor?.id)}
                  {...registerLotacao('defensor.id')}
                >
                  <option value="">Selecione um defensor</option>
                  {defensores.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
                <FieldError message={errorsLotacao.defensor?.id?.message} />
              </Form.Group>
              <Form.Group as={Col} md="6" className="mb-3">
                <label htmlFor="inicio" className="form-label">
                  Início: <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  id="inicio"
                  className={formControlClass(!!errorsLotacao.inicio)}
                  {...registerLotacao('inicio')}
                />
                <FieldError message={errorsLotacao.inicio?.message} />
              </Form.Group>
              <Form.Group as={Col} md="6" className="mb-3">
                <label htmlFor="fim" className="form-label">
                  Fim:
                </label>
                <input
                  type="date"
                  id="fim"
                  className="form-control"
                  {...registerLotacao('fim')}
                />
              </Form.Group>
              <Form.Group as={Col} md="12" className="mb-3">
                <div className="form-check">
                  <input
                    type="checkbox"
                    id="diretor"
                    className="form-check-input"
                    {...registerLotacao('diretor')}
                  />
                  <label className="form-check-label" htmlFor="diretor">
                    Diretor(a) desta diretoria regional
                  </label>
                </div>
              </Form.Group>
            </Row>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setModalLotacaoShow(false)}>
                Fechar
              </Button>
              <Button type="submit" variant="success">
                Salvar
              </Button>
            </Modal.Footer>
          </form>
        </Modal.Body>
      </Modal>

      <Modal show={modalDefensoriaShow} onHide={() => setModalDefensoriaShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Associar Defensoria</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Defensoria</Form.Label>
            <Form.Select
              value={defensoriaSelecionadaId}
              onChange={(e) => setDefensoriaSelecionadaId(e.target.value)}
            >
              <option value="">Selecione uma defensoria</option>
              {defensoriasDisponiveis.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </Form.Select>
            {defensoriasDisponiveis.length === 0 && (
              <small className="text-muted d-block mt-2">
                Todas as defensorias já estão associadas a esta diretoria.
              </small>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalDefensoriaShow(false)}>
            Fechar
          </Button>
          <Button variant="success" onClick={() => void handleAssociarDefensoria()} disabled={!defensoriaSelecionadaId}>
            Associar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

